import { Injectable } from '@angular/core';

export interface IFileWithExtension {
  name: string;
  fileExtension?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FileExtensionMatcherService {
  matchesAllowedExtension(file: IFileWithExtension, allowedExtensions: string[]): boolean {
    const normalizedAllowedExts = allowedExtensions.map((ext) => this.normalizeExtension(ext));

    if (file.fileExtension) {
      const fileExt = this.normalizeExtension(file.fileExtension);
      return normalizedAllowedExts.includes(fileExt);
    } else {
      const lowerFileName = file.name.toLowerCase();
      return normalizedAllowedExts.some((ext) => {
        return lowerFileName.endsWith(`.${ext}`) || lowerFileName.endsWith(ext);
      });
    }
  }

  private normalizeExtension(extension: string): string {
    const lower = extension?.toLowerCase();
    return lower?.startsWith('.') ? lower?.substring(1) : lower;
  }
}
